import { allowBuyCredits } from "@/components/helpers/workspace/permissions";
import { Box } from "@/components/layout/flexbox";
import OrderDetailTable from "@/components/pieces/buy-credits/OrderDetailTable";
import PrettyBox from "@/components/pieces/PrettyBox";

import GiftCodeSelector from "./GiftCodeSelector";
import PromoCodeSelector from "./PromoCodeSelector";

export default function OrderSummary({
  order,
  loading,
  setOrder,
  paymentMethodId,
  orderCreditTotal,
  onCompletedRedeemGiftCode,
}) {
  return (
    <PrettyBox>
      <Box fontSize={22} fontWeight={600}>
        Order summary
      </Box>
      <Box mt={4}>
        <OrderDetailTable
          order={order}
          paymentType={paymentMethodId === "CREDITS" ? "CREDITS" : "FIAT"}
        />
        {allowBuyCredits() && (
          <>
            <Box mt={3}>
              <PromoCodeSelector
                order={order}
                loading={loading}
                setOrder={setOrder}
              />
            </Box>
            <Box mt={3}>
              <GiftCodeSelector
                order={order}
                loading={loading}
                paymentMethodId={paymentMethodId}
                orderCreditTotal={orderCreditTotal}
                setOrder={setOrder}
                onCompletedRedeemGiftCode={onCompletedRedeemGiftCode}
              />
            </Box>
          </>
        )}
      </Box>
    </PrettyBox>
  );
}
